<template>
  <div class="footer">
    <img src="@/assets/images/m_bg5.png" alt="" class="bg-ft">
    <div class="footer-content">
      <div class="footer-content-l">
        <div class="title">Ready to be the </div>
        <div class="title">owner of a club?</div>
        <div class="btn">
          <a href="https://discord.gg/J3uKnUtbSM" target="_blank">
            <label class="text">Start it now! <img src="@/assets/images/arraw_r.svg" alt=""></label>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </a>
        </div>
      </div>
      <div class="footer-content-r">
        <img src="@/assets/images/m_pass_card.png" alt="">
      </div>
    </div>
    <div class="contact">
      <div class="contact-list flex-center-center">
        <a href="https://discord.gg/J3uKnUtbSM" target="_blank">
          <svg width="27px" height="20px" viewBox="0 0 27 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <title>Discord-Logo-White</title>
            <g id="Spola-Labs" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="1">
              <g id="HOME" transform="translate(-1202.000000, -8912.000000)" fill="#778AA2" fill-rule="nonzero">
                <g id="底部" transform="translate(0.000000, 8799.500000)">
                  <g id="Discord-Logo-White" transform="translate(1202.760856, 112.500000)">
                    <path d="M22.2125434,1.65789087 C20.5401491,0.89052528 18.7467591,0.325164134 16.8716582,0.00135832336 C16.8375104,-0.00489102752 16.8033995,0.0107264366 16.7858082,0.0419621041 C16.5551624,0.452183761 16.2996819,0.987351415 16.1207752,1.40799075 C14.103983,1.10605582 12.0975385,1.10605582 10.1221006,1.40799075 C9.943157,0.97800141 9.67840035,0.452183761 9.4467198,0.0419621041 C9.42912849,0.0117686111 9.3950176,-0.0038488531 9.36086976,0.00135832336 C7.48680363,0.324129351 5.69341362,0.889490497 4.01998454,1.65789087 C4.00549757,1.66413653 3.99308018,1.67455827 3.98483887,1.68808437 C0.58315568,6.77012599 -0.348707537,11.7272545 0.108433404,16.6229243 C0.110501861,16.6468721 0.12394702,16.6697852 0.142563877,16.6843461 C2.38689722,18.3325338 4.56091741,19.3331321 6.69456628,19.9963542 C6.72871412,20.0067759 6.76489458,19.9942846 6.78662502,19.9661607 C7.29134049,19.2769212 7.7412494,18.5501709 8.12700176,17.7859096 C8.14976699,17.7411553 8.12803655,17.6880487 8.08150826,17.6703465 C7.36787748,17.3996399 6.68835758,17.069581 6.03470726,16.6947678 C5.98300506,16.6645743 5.97886593,16.5906243 6.026429,16.5552199 C6.16398124,16.4521481 6.30157044,16.3449002 6.43291398,16.2366176 C6.45667703,16.2168458 6.48979009,16.2126697 6.51772924,16.225161 C10.8119313,18.1857424 15.4609162,18.1857424 19.7044509,16.225161 C19.7323901,16.211635 19.7655031,16.215811 19.790301,16.2355828 C19.9216815,16.3438655 20.0592337,16.4521481 20.1978207,16.5552199 C20.2453838,16.5906243 20.2422794,16.6645743 20.1905772,16.6947678 C19.5369269,17.0768615 18.857407,17.3996399 18.1427415,17.6693118 C18.0962132,17.6870139 18.0755175,17.7411553 18.0982827,17.7859096 C18.4923134,18.5490991 18.9422223,19.2758495 19.4376247,19.9651259 C19.4583204,19.9942846 19.4955356,20.0067759 19.5296834,19.9963542 C21.6736801,19.3331321 23.8476855,18.3325338 26.0920193,16.6843461 C26.1116801,16.6697852 26.1240975,16.6479069 26.1261671,16.6239591 C26.6732717,10.964028 25.2097927,6.04755172 22.2466543,1.68911915 C22.2394108,1.67455827 22.2270304,1.66413653 22.2125434,1.65789087 Z M8.76827164,13.6419728 C7.47542101,13.6419728 6.41014875,12.4550396 6.41014875,10.9973628 C6.41014875,9.53968604 7.45476231,8.35275285 8.76827164,8.35275285 C10.0920919,8.35275285 11.1470532,9.55010778 11.1263576,10.9973628 C11.1263576,12.4550396 10.081744,13.6419728 8.76827164,13.6419728 Z M17.4870216,13.6419728 C16.1942079,13.6419728 15.1289356,12.4550396 15.1289356,10.9973628 C15.1289356,9.53968604 16.1735122,8.35275285 17.4870216,8.35275285 C18.8108787,8.35275285 19.8658032,9.55010778 19.8451445,10.9973628 C19.8451445,12.4550396 18.8108787,13.6419728 17.4870216,13.6419728 Z" id="形状"></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </a>
        <a href="https://twitter.com/SpolaLabs" target="_blank">
          <svg width="26px" height="26px" viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <title>形状结合</title>
            <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Spola-PASS" transform="translate(-975.000000, -4931.000000)" fill="#778AA2" fill-rule="nonzero">
                <g id="编组-24" transform="translate(919.380428, 4931.778474)">
                  <path d="M68.7391439,0 C75.6427033,0 81.2391439,5.59644063 81.2391439,12.5 C81.2391439,19.4035594 75.6427033,25 68.7391439,25 C61.8355845,25 56.2391439,19.4035594 56.2391439,12.5 C56.2391439,5.59644063 61.8355845,0 68.7391439,0 Z M71.8222084,5.98650255 C70.0067161,5.98650255 68.5343476,7.45827674 68.5343476,9.27483022 C68.5343476,9.53221562 68.5633375,9.78331919 68.6190675,10.0244058 C65.8860879,9.88705433 63.4631252,8.57792869 61.8413086,6.58870968 C61.5581167,7.07453311 61.39602,7.63938879 61.39602,8.24206282 C61.39602,9.3827674 61.9766227,10.389219 62.8588383,10.9787776 C62.3365813,10.9625939 61.825786,10.8216257 61.3691524,10.567657 L61.3691524,10.6092105 C61.3691524,12.2025891 62.5024716,13.5311969 64.0068858,13.8333616 C63.7305276,13.9090832 63.4405021,13.9486418 63.1404597,13.9486418 C62.9283205,13.9486418 62.7225055,13.9285654 62.5214444,13.890747 C62.9399079,15.1967317 64.1543392,16.1473684 65.5928791,16.174236 C64.4674546,17.0564516 63.0493731,17.582343 61.5091779,17.582343 C61.2438977,17.582343 60.9817161,17.566511 60.7243307,17.5354839 C62.179806,18.4687606 63.907947,19.0135823 65.7650353,19.0135823 C71.8132526,19.0135823 75.1210624,14.0028862 75.1210624,9.65755518 C75.1210624,9.51489813 75.1179215,9.37330221 75.1110454,9.23221562 C75.7555133,8.76606921 76.3118327,8.18889516 76.7539572,7.52771647 C76.1643561,7.78934635 75.5310794,7.96621392 74.8652475,8.04571307 C75.5447891,7.63879457 76.0653748,6.99397284 76.3111728,6.22652801 C75.6656635,6.60992318 74.9592117,6.87983316 74.2225055,7.02453311 C73.6229724,6.38548387 72.7680488,5.98650255 71.8222084,5.98650255 Z" id="形状结合"></path>
                </g>
              </g>
            </g>
          </svg>
        </a>
      </div>
      <div class="msg">© 2022 Spola Labs PTE. LTD. All Rights Reserved.</div>
    </div>
    <div class="to-top" data-aos="fade-up" data-aos-anchor-placement="bottom-bottom" :data-aos-once="false" @click="toTop">TOP</div>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  methods: {
    toTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    }
  },
}
</script>
<style lang="scss" scoped>
.footer {
  margin-top: 1.6rem;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  z-index: 9;
  padding-bottom: .4rem;
  .bg-ft {
    position: absolute;
    top: .21rem;
    left: 0;
    right: 0;
    width: 100%;
    height: auto;
    z-index: 0;
    object-fit: cover;
  }
  .footer-content {
    position: relative;
    z-index: 2;
    margin: auto;
    font-size: 0;
    .footer-content-l {
      .title {
        font-size: .48rem;
        font-family: DINPro-Bold, DINPro;
        color: #FFFFFF;
        line-height: .52rem;
        letter-spacing: 1px;
        text-transform: uppercase;
        text-align: center;
      }
      .btn {
        margin: auto;
        margin-top: .91rem;
        width: 3rem;
        height: .52rem;
        background: #171619;
        border-radius: .5rem;
        font-size: .24rem;
        font-family: DINPro-Bold, DINPro;
        color: #FFFFFF;
        line-height: .31rem;
        text-transform: uppercase;
        cursor: pointer;
        a {
          width: 100%;
          height: 100%;
          display: flex;
          font-family: DINPro-Bold;
          align-items: center;
          justify-content: center;
          font-size: inherit;
          position: relative;
          .text {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            font-family: DINPro-Bold;
            position: relative;
            z-index: 9;
            justify-content: center;
            background: #171619;
            border-radius: .58rem;
            cursor: pointer;
            img {
              width: .12rem;
              height: auto;
              margin-left: .28rem;
              position: relative;
              transition: all .5s;
              right: 0;
            }
          }
          span {
            position: absolute;
            left: 50%;
            top: 0;
            bottom: 0;
            border-radius: 58px;
            transition: all .5s;
            &:nth-child(2) {
              right: -.05rem;
              left: -.05rem;
              background: #1C42FF;
              opacity: 0.7;
              z-index: 8;
            }
            &:nth-child(3) {
              right: -.09rem;
              left: -.09rem;
              background: #4BE9F2;
              opacity: 0.7;
              z-index: 7;
            }
            &:nth-child(4) {
              right: -.13rem;
              left: -.13rem;
              background: #ECFF7B;
              z-index: 6;
              opacity: 0.7;
            }
            &:nth-child(5) {
              right: -.39rem;
              left: -.39rem;
              background: #1C42FF;
              opacity: 0.5;
            }
            &:nth-child(6) {
              right: -.61rem;
              left: -.61rem;
              background: #1C42FF;
              opacity: 0.5;
            }
            &:nth-child(7) {
              right: -.98rem;
              left: -.98rem;
              background: #1C42FF;
              opacity: 0.1;
            }
          }
        }
      }
    }
    .footer-content-r {
      margin-top: .15rem;
      position: relative;
      width: 100%;
      text-align: center;
      img {
        width: 5.58rem;
        height: auto;
        margin: auto;
      }
    }
  }
  .contact {
    margin: auto;
    margin-top: .86rem;
    position: relative;
    .contact-list {
      a {
        font-size: 0;
        & ~ a {
          margin-left: .52rem;
        }
      }
      svg {
        width: .46rem;
        height: auto;
        cursor: pointer;
        &:hover {
          path {
            fill: #FFFFFF
          }
        }
      }
    }
    .msg {
      font-size: .18rem;
      font-family: DINPro-Regular, DINPro;
      font-weight: 400;
      color: #778AA2;
      line-height: .32rem;
      margin-top: .3rem;
      text-align: center;
    }
  }
  .to-top {
    position: absolute;
    right: 1.29rem;
    bottom: 1.62rem;
    width: .86rem;
    height: .86rem;
    background: rgba($color: #171619, $alpha: .8);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: .24rem;
    font-family: DINPro-Bold, DINPro;
    color: #FFFFFF;
    line-height: .31rem;
    cursor: pointer;
    z-index: 99;
    border: 1px solid #3A3A3A;
    border-radius: .86rem;
  }
}
</style>